module.exports = __webpack_public_path__ + "static/media/instagram-pink-on-blue.47afaa72.svg";